import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getAvailablePages } from 'utils';

import { get, useApplicationState } from '@atlas/core';
import { CLIENT_PROFILE_COMPONENT_TYPES, clientProfileRoutes } from '@atlas/routing';

import Router from 'common/Router/Router';
import { defaultRoutes } from 'components/MainRouter/constants';
import MessagesRouter from 'components/Messages/MessagesRouter';
import PromoCodes from 'src/components/PromoCodes/PromoCodes';

import Bonuses from './Bonuses/Bonuses';
import History from './History/History';
import Payment from './Payment/Payment';
import Profile from './Profile/Profile';
import ResponsibleGaming from './ResponsibleGaming/ResponsibleGaming';
import Achievements from './Achievements';
import CashbackPage from './Cashback';
import Verification from './Verification';

const {
  achievements,
  bonuses,
  cashback,
  history,
  messages,
  payment,
  profile,
  promoCodes,
  responsibleGaming,
  verification,
} = clientProfileRoutes;

const {
  ACHIEVEMENTS,
  BONUSES,
  CASHBACK,
  HISTORY,
  MESSAGES,
  PAYMENT,
  PROFILE,
  PROMO_CODES,
  RESPONSIBLE_GAMING,
  VERIFICATION,
} = CLIENT_PROFILE_COMPONENT_TYPES;

const { account } = defaultRoutes;

const getRoutes = clientProfileRoute => ({
  [ACHIEVEMENTS]: {
    component: Achievements,
    defaultPath: `${clientProfileRoute}/${achievements}`,
  },
  [BONUSES]: {
    component: Bonuses,
    defaultPath: `${clientProfileRoute}/${bonuses}`,
    optionalPath: '/:bonusId?',
  },
  [CASHBACK]: {
    component: CashbackPage,
    defaultPath: `${clientProfileRoute}/${cashback}`,
  },
  [HISTORY]: {
    component: History,
    defaultPath: `${clientProfileRoute}/${history}`,
  },
  [MESSAGES]: {
    component: MessagesRouter,
    defaultPath: `${clientProfileRoute}/${messages}`,
    optionalPath: '/:messageId?',
  },
  [PAYMENT]: {
    component: Payment,
    defaultPath: `${clientProfileRoute}/${payment}`,
  },
  [PROFILE]: {
    component: Profile,
    defaultPath: `${clientProfileRoute}/${profile}`,
  },
  [PROMO_CODES]: {
    component: PromoCodes,
    defaultPath: `${clientProfileRoute}/${promoCodes}`,
  },
  [RESPONSIBLE_GAMING]: {
    component: ResponsibleGaming,
    defaultPath: `${clientProfileRoute}/${responsibleGaming}`,
  },
  [VERIFICATION]: {
    component: Verification,
    defaultPath: `${clientProfileRoute}/${verification}`,
  },
});

const ClientProfileRouter = ({ clientProfilePath, clientProfileTabs = [] }) => {
  const applicationState = useApplicationState();
  const resolved = get(applicationState, 'resolved');

  const routerRoutes = useMemo(() => {
    const availableRoutes = getRoutes(clientProfilePath);
    return getAvailablePages(availableRoutes, clientProfileTabs);
  }, [clientProfilePath, clientProfileTabs]);

  if (!resolved) {
    return null;
  }

  return <Router redirectFrom={clientProfilePath} redirectTo={account} routes={routerRoutes} />;
};

ClientProfileRouter.propTypes = {
  clientProfilePath: PropTypes.string.isRequired,
  clientProfileTabs: PropTypes.array,
};

export default ClientProfileRouter;
